import React from 'react';
import PropTypes from 'prop-types';
import StyledDivider from './Styles';

const Divider = ({ text }) => (
  <StyledDivider.Wrapper>
    <StyledDivider.Text>{text}</StyledDivider.Text>
  </StyledDivider.Wrapper>
);

Divider.propTypes = {
  text: PropTypes.string
};

Divider.defaultProps = {
  text: ''
};

export default React.memo(Divider);
